"use strict";

window.isIE11 = {};
window.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if(typeof svg4everybody !== 'undefined') {
  // SVG helper
  svg4everybody();
}
// window.scroll(0,0);

window.isEmpty = function (obj) {
  for (var key in obj) {
    return false; // /*/ если цикл хоть раз сработал, то объект не пустой => false */
  };
  return true; // /*/ дошли до этой строки - значит цикл не нашёл ни одного свойства => true */
};

window.isSafari = false;
var userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf('safari') != -1) {
  if (userAgent.indexOf('chrome') > -1) {
    window.isSafari = false;
  } else {
    window.isSafari = true;
  }
};

if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
  $('body').on("mousewheel", function (event) {
      // remove default behavior
      event.preventDefault();

      //scroll without smoothing
      var wheelDelta = event.wheelDelta;
      var currentScrollPosition = window.pageYOffset;
      window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
};

var

supportFormatWebp = function(){
  var elem = document.createElement('canvas');
  if (!!(elem.getContext && elem.getContext('2d'))) {
   return (elem.toDataURL('image/webp').indexOf('data:image/webp') == 0);
  }
  else {
   return false;
  }
};

window.webpSupport = supportFormatWebp();

var

isInViewport = function(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
},

trackGAEvent = function(category, label, action){
  action = (typeof action === "undefined") ? 'click' : action;
  if (typeof ga !== "undefined") {
    ga('send', 'event', category, action, label, { 'hitCallback': function(){} });
  }
  // console.log('trackGAEvent', label);
  return true;
},
trackOutboundLink = function(url){
  trackGAEvent('outbound', url);
},

reachGoal = function(_ID, _TARGET){
  if (typeof ym !== "undefined") {
    ym(_ID, 'reachGoal', _TARGET);
  }
  // console.log('reachGoal', _TARGET);
  return true;
},

goals = function($this) {
  var
    _ymid = $this.data('ymid'),
    _ymt = $this.data('ymt'),
    _gac = $this.data('gacategory'),
    _gal = $this.data('galabel'),
    _gaa = $this.data('gaaction');
  if (typeof _ymt === "undefined") {} else {
    reachGoal(_ymid, _ymt);
    console.log('reachGoal', _ymt);
  }
  if (typeof _gal === "undefined") {} else {
    trackGAEvent(_gac, _gal, _gaa);
    console.log('trackGAEvent', _gal);
    console.log('trackGAEvent', _gaa);
  }

  // return false;
},

showMap = function() {
  var _map;

  if ($('.job').length > 0) {
    if ((window.innerWidth > 767) && (window.innerWidth <= 1199)) {
      $('#mapShops').css({ height: 530 }).hide();
    } else if (window.innerWidth > 1199) {
      $('#mapShops').css({ height: 700 }).hide();
    } else {
      $('#mapShops').css({ height: 300 }).hide();
    }
  } else {
    $('#mapShops').css({ height: 450 }).hide();
  }

  var _brand = $('[data-brand]').data('brand');

  function init () {
    var _map = new ymaps.Map("mapShops", {
      // center: [54.985097819556316, 73.35857632528676],
      // center: [54.97026898640075, 73.40097751925968],
      center: [54.970268, 73.400977],
      zoom: 10,
      // type: "yandex#satellite",
      controls:['zoomControl']
    }, {
      suppressMapOpenBlock: true
    }),
    // searchControl = new ymaps.control.SearchControl({
    //   options: {
    //     provider: 'yandex#search'
    //   }
    // }),
    objectManager = new ymaps.ObjectManager({
      clusterize: false,
      gridSize: 32,
      clusterDisableClickZoom: true,
    });

    // _map.controls.add(searchControl);
    // searchControl.search('Hot Омск');

    _map.behaviors.disable('scrollZoom');

    var _presetIcon = 'islands#blackDotIcon';
    if(_brand == 'tapi') {
      _presetIcon = 'islands#darkOrangeDotIcon';
    }
    objectManager.objects.options.set('preset', _presetIcon);

    // objectManager.objects.options.set('iconLayout', 'default#image');
    // objectManager.objects.options.set('iconImageHref', '/images/logo-icon-48x48.png');
    // objectManager.objects.options.set('iconImageSize', [42, 42]);
    // objectManager.objects.options.set('iconImageOffset', [-21, -21]);

    objectManager.clusters.options.set('preset', 'islands#blackClusterIcons');
    _map.geoObjects.add(objectManager);

    $.ajax({
      url: "/outlets?map=true",
      dataType: "json"
    }).done(function(data) {
      objectManager.add(data);
      _map.setBounds(objectManager.getBounds());
    });

  }

  // $('#mapShops').slideDown(800, function(){
  //   ymaps.ready(init);
  // });

  (async() => {
    do {
      if(typeof ymaps == 'object') {
        $('#mapShops').slideDown(800, function(){
          ymaps.ready(init);
        });
      }
    } while (!window.hasOwnProperty("ymaps"));
  })();
},

// Навигация по якорям
scrollPage = function (id, delay){
  var
    idOffsetTop = Math.round( $(id).offset().top ),
    bodyOffsetTop = $('body').offset().top,
    _headerHeight = ( $('.header').length )? $('.header').outerHeight(true) : 0,
    _navbarHeight = ( $('.navbar').length )? $('.navbar').outerHeight(true) : 0,
    topTarget = (($(id).length)? $(id).offset().top - _navbarHeight - 3: 0),
    _paddingTop = -(_navbarHeight - 10);

  if (delay) {
    delay = 300;
  };

  if($('[role="tab"][href="'+ id +'"]').length > 0) {
    var _parentId = $(id).parents('.tab-pane').attr('id');
    if (_parentId !== undefined) {
      $('[href="#'+ _parentId +'"]').tab('show');
    }
    $('[href="'+ id +'"]').tab('show');
    var _tabList = parseInt( $('[role="tab"][href="'+ id +'"]').parents('.tabs__nav').outerHeight(true) );
    _paddingTop = (($(id).hasClass('tab-pane'))? (( window.innerWidth > 767 ) ? (_tabList + 44) : 5 ) : 0);
  }

  var $chScrollPositions = Math.round( idOffsetTop - (_paddingTop) - _headerHeight - _navbarHeight - 30);

  $('html,body').delay(delay)
    .animate({
      // scrollTop: $chScrollPositions
      scrollTop: topTarget
    }, 400, 'swing');

  if( !$('.navbar .navbar-toggler').hasClass('collapsed') ){
    $('.navbar .navbar-toggler').addClass('collapsed');
    $('.navbar-collapse').collapse('hide');
  }

  return true;
},

urlParams = new URLSearchParams(window.location.search)

;$(function() {

  if(!!window.webpSupport) {
    $('html').addClass('webp');
  };

  if(!$.cookie('cookieAgree')) {
    var $cookieAgree = $('<div id="cookieAgree" style="display:none;"><button type="button" class="close" title="Соглашаюсь"><i class="fa fa-check" aria-hidden="true"></i></button><span>Мы используем cookie для быстрой и удобной работы сайта. Используя наш сайт, вы принимаете <a target="_blank" class="text-primary" href="//www.coffee-anytime.ru/privacy-policy" rel="nofollow">условия обработки персональных данных</a>.</div>');
    $('body').append($cookieAgree);
    $('#cookieAgree').show('slow');
    $('#cookieAgree').on('click', '.close', () => {
      $('#cookieAgree').hide('slow');
      $.cookie('cookieAgree', 1);
    });
  }

  $('._goals')
  .not('form')
  .on('click', function(event){
    // event.preventDefault();
    return goals($(this));
  });

  $('form._goals').on('submit', function(event){
    // event.preventDefault();
    return goals($(this));
  });

  var utmSource = urlParams.get('utm_source'),
    utmContent = urlParams.get('utm_content');

  if(utmSource == 'qrcode' && (window.innerWidth < 767)) {

    console.log('utmSource', utmSource);
    console.log('utmContent', utmContent);

    if(utmContent == 'nav') {
      $('.navbar-toggler').trigger('click');
    }
    else if(utmContent == 'navmenu') {
      $('.navbar-toggler').trigger('click');
      $('[href="/#menu"]').trigger('click');
    }
  }

  if ( $('[data-inputmask]').length > 0) {
    $("[data-inputmask]").inputmask("+7(999)999-99-99");
  }

  // Menu
  var collapseAllNavbar = function(){
    $('.navbar-collapse').collapse('hide');
  };

  var navHeight = $('.navbar').height();
  if ($('#coffee').length > 0 || $('.franchise').length > 0) { // проверяем, на главной ли странице мы находимся
    // $('.nav-link, .dropdown-item')
    $('.nav-link')
    .not('.dropdown-toggle')
    .on('click', function (event) {
      // event.preventDefault();
      var
        _id = ($(this).attr('href')[0] === '/') ? $(this).attr('href').slice(1) : $(this).attr('href'),
        _offset = $(_id).offset().top,
        top = _offset - navHeight + 3;
      // document.location.hash = _id;
      // $('body,html').animate({scrollTop: top}, 400);

      if ($(_id).hasClass('tab-pane')) {
        $('[href="'+_id+'"]').trigger('click');
      }

      setTimeout(function(){
        $.when( scrollPage(_id) ).done(function(){
          document.location.hash = _id;
          // document.location.hash = '#';
        });

        collapseAllNavbar();
      }, 500);

      return true;
    });
  }

  var scrollHash = function(){
    if (document.location.hash.length > 0) {
      var
        navHeight = $('.navbar').height(),
        idTarget = document.location.hash;

      if ( !idTarget ) {
        // scroll(0,0);
        window.scroll(0,0);
      }
      else if(idTarget && idTarget == '#opennav' && (window.innerWidth < 767)) {
        $('.navbar-toggler').trigger('click');
      }

      if ( $(idTarget).length > 0 ) {
        // var topTarget = (($(idTarget).length)? $(idTarget).offset().top - navHeight + 3: 0);
        if ($(idTarget).hasClass('tab-pane')) {
          $('[href="'+idTarget+'"]').trigger('click');
        }

        setTimeout(function(){
          $.when( scrollPage(idTarget) ).done(function(){
            document.location.hash = idTarget;
            // document.location.hash = '#';
          });
        }, 1500);

        // setTimeout(function(){
        //   // $('body,html').scrollTop(topTarget);
        //   $('html,body').delay(300)
        //     .animate({
        //       scrollTop: topTarget
        //     }, 400, 'swing');
        // }, 1500);
        // document.location.hash = idTarget;
      }
    }
  };

  // if($('.needs-validation').length > 0) {
  // 	(function() {
  // 		'use strict';
  // 		window.addEventListener('load', function() {
  // 			// Fetch all the forms we want to apply custom Bootstrap validation styles to
  // 			var forms = document.getElementsByClassName('needs-validation');
  // 			// Loop over them and prevent submission
  // 			var validation = Array.prototype.filter.call(forms, function(form) {
  // 				form.addEventListener('submit', function(event) {
  // 					if (form.checkValidity() === false) {
  // 						event.preventDefault();
  // 						event.stopPropagation();
  // 					}
  // 					form.classList.add('was-validated');
  // 				}, false);
  // 			});
  // 		}, false);
  // 	})();
  // }

  if ($('#carousel-main').length>0) {
    var carouselMain = $('#carousel-main');
    $.when(
      carouselMain.carousel()
    ).then(
      function(){
        scrollHash();
      }, function(){
        console.log('carousel error');
      }
    );
  }

  if ( $('#map').length > 0 ){
    var mapInit = false;
    $(window).on("scroll resize", function() {
      if(!mapInit && isInViewport($('#map'))) {
        $('#map').css({'min-height': 450});
        mapInit = true;
        var urlMap = 'https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A292c45f55a7e3eafcdf0f8acad36c907b53d44c6f4e4959baa25884b8d5770d0&amp;width=100%25&amp;height=450&amp;lang=ru_RU&amp;scroll=false&amp;id=map';
        (function(document, tag) {
            var scriptTag = document.createElement(tag),
              firstScriptTag = document.getElementsByTagName(tag)[0];
            scriptTag.src = urlMap;
            firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }(document, 'script'));
      }
    });
  }

  if ( $('#mapShops').length > 0 ){
    var urlApi = 'https://www.coffee-anytime.ru/api/yandex/2.1/';
    (function(document, tag) {
        var scriptTag = document.createElement(tag),
          firstScriptTag = document.getElementsByTagName(tag)[0];
        scriptTag.src = urlApi;
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    }(document, 'script'));

    $('#mapShops')
      .addClass('w-100')
      .addClass('mapShops')
      // .addClass('map')
      .html('');

    $('.brand_tapi #mapShops').after('<img class="img-fluid mx-auto d-block mt-4" width="270" src="/images/tapi-tea/koala.svg" alt="">');
    $('#mapShops').css({'min-height': 450});

    var mapInit = false;
    $(window).on("scroll resize", function() {
      if(!mapInit && isInViewport($('#mapShops'))) {
        if ($('.job').length > 0) {
          if ((window.innerWidth > 767) && (window.innerWidth <= 1199)) {
            $('#mapShops').css({'min-height': 530});
          } else if (window.innerWidth > 1199) {
            $('#mapShops').css({'min-height': 700});
          } else {
            $('#mapShops').css({'min-height': 300});
          }
        } else {
          $('#mapShops').css({'min-height': 450});
        }
        mapInit = true;

        // Показываем карту
        showMap();
      }
    });
  }

  // Products - по 2 карточки в строке, когда всего 4 карточки
  $('.products').each(function() {
    if(($(this).children().length === 4) && (window.innerWidth > 991)) {
      $(this).addClass('has-4-cards');
    }
  });

  // Создаем слайдер для товаров с несколькими изображениями
  $('.products__item').each(function() {
    var _productItem = $(this);
    if (_productItem.find('img').length > 1) {
      var _productItemImgs = _productItem.find('img');
      var _productItemImgsWrap = $('<div class="__imgs-wrap"></div>');
      _productItem.find('img').each(function(){
        var _productItemImg = $(this);
        _productItemImg.appendTo(_productItemImgsWrap);
      });

      _productItemImgsWrap.slick({
        autoplay: false,
        autoplaySpeed: 10000,
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        // nextArrow: '<button type="button" class="slick-next fa fa-angle-right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        // prevArrow: '<button type="button" class="slick-prev fa fa-angle-left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',

        responsive: [
          {
            breakpoint: 1200,
            settings: {
              autoplay: false,
              // arrows: true
            }
          },
          {
            breakpoint: 992,
            settings: {
              autoplay: false,
              // arrows: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              autoplay: false,
              // arrows: false
            }
          },
          {
            breakpoint: 576,
            settings: {
              autoplay: false,
              // arrows: false
            }
          }
        ]
      });

      // _productItemImgsWrap.append(_productItemImgs);
      _productItemImgsWrap.prependTo(_productItem);
    }
    // console.log('_productItem > img', _productItem.find('img').length);
  })

  // Video
  if ($('.video').length > 0) {
    $('.video__link').removeAttr('href');
    $('.video').on('click', '.video__button, .video__link', function () {
      var
        $video = $(this).parents('.video'),
        videoId = $video
          .find('.video__media')
          .not('iframe')
          .attr('data-attribute'),
        videoHost = $video
          .find('.video__media')
          .not('iframe')
          .attr('data-host'),
        embedAttr,
        $embed = $('<iframe>');

      if ($('.video').hasClass('_vk')) {
        embedAttr = {
          'src': 'https://vkvideo.ru/video_ext.php?oid=-' + videoId + '&autoplay=1',
          'allowfullscreen': '',
          'allow': 'autoplay'
        };
      } else {
        embedAttr = {
          'src': 'https://www.youtube.com/embed/' + videoId + '?rel=0&showinfo=0&autoplay=1&fs=0',
          'allowfullscreen': '',
          'allow': 'autoplay'
        };
      }

      // console.log('videoId', videoId);
      // console.log('videoHost', videoHost);
      if(videoHost !== undefined && videoHost == 'vk') {
        embedAttr = {
          'src': 'https://vk.com/video_ext.php?' + videoId,
          'allowfullscreen': '',
          'allow': 'autoplay; encrypted-media;'
        }
      }
      // console.log('embedAttr', embedAttr);
      $embed.addClass('video__media').attr(embedAttr);

      // console.log('videoId', videoId);

      $video.empty();
      $video.append($embed);
      return false;
    });
  }

  // Form on job page
  // if ( window.innerWidth > 991 ) {
  //   $(window).on('scroll', function() {
  //     var form = $('.job__form'),
  //         scrollTop = parseInt($(window).scrollTop()),
  //         formArea = parseInt($('footer').offset().top) - scrollTop,
  //         formIndents = 110, //в стилях: 60px (значение top .job__form) + 50px (значение bottom .job__form.affix-bottom)
  //         formMinArea = form.outerHeight() + formIndents;

  //     if (scrollTop > $('header').outerHeight() && formArea >= formMinArea) {
  //       form.removeClass('affix-bottom');
  //       form.addClass('affix');
  //     } else if (formArea < formMinArea) {
  //       form.removeClass('affix');
  //       form.addClass('affix-bottom');
  //     } else {
  //       form.removeClass('affix-bottom affix');
  //     }
  //   });
  // }

  // Click on button in job page footer
  $('.job__btn._in-footer').on('click', function () {
    if (!$("#collapseForm").hasClass("show")) {
      $("#collapseForm").addClass("show");
    }

    $('body,html').scrollTop($("#collapseForm").offset().top - 20);
  });

  $('#collapseForm').on('shown.bs.collapse', function () {
    $('body,html').scrollTop($("#collapseForm").offset().top - 20);
  });

  $('#suppliers_form, #reviews_form, #feedback_form, #job_form')
  .on('submit', function(){
    if($('.form-control:invalid,.custom-control-input:invalid').length == 0) {
      $(this)
        .find('input[type="submit"]')
        .removeClass('btn-warning')
        .addClass('btn-secondary')
        .addClass('progress-bar-striped')
        .addClass('progress-bar-animated')
        .val('Отправка...')
        .prop('disabled',true);
    }
  });

  if ($('.newyear').length > 0) {
    if(typeof $.snow === 'function') {
      // $(window).on('load', () => {
        $.snow({
          // flakeList: ['❄', '❅', '❆'],
          minSize: 10,
          maxSize: 32,
          newOn: 450,
          flakeColor: ["#ffffff"],
          target: ".header__intro"
        });
      // });
    }
  }

  if ($('.newyear-tapi').length > 0) {
    if(typeof $.snow === 'function') {
      $.snow({
        // flakeList: ['❄', '❅', '❆'],
        minSize: 10,
        maxSize: 32,
        newOn: 450,
        flakeColor: ["#ffffff"],
        target: ".tapi-tea__header"
      });
    }
  }

  if($.jqmarquee !== undefined) {
    $.jqmarquee();
  }

  function lazyloadCall() {
    if ($('[data-lazyload]').length > 0) {
      $('img[data-lazyload="true"],img[data-lazyload="1"]').lazyload();
    }
  }

  lazyloadCall();

  if($('#accordion').length > 0) {
    var _accordionBak = $('#accordion').html();

    function wrap4Accordion() {
      if($('.outlets-category_title').length > 0 && ( window.innerWidth <= 767 )) {
        if($('.outlets-category_title button').length == 0) {
          $('.outlets-category_title').each(function(index, item){
            var
              _item = $(item),
              _categoryId = _item.data('outletscategoryid'),
              _categoryList = $('#outletsCategory'+ _categoryId +''),
              _subtitle = $('.outlets-category_subtitle[data-outletscategoryid="'+ _categoryId +'"]'),
              _subtitleTxt = _subtitle.text();
            _subtitle.remove();
            _item.append($('<div class="small">'+_subtitleTxt+'</div>').css({'font-size': '.55em', 'font-weight': 'normal'}));
            _item.wrapInner('<button class="collapsed" data-toggle="collapse" data-target="#outletsCategory'+ _categoryId +'" aria-expanded="false" aria-controls="outletsCategory'+ _categoryId +'" />');
            _categoryList.addClass('collapse');
            _categoryList.attr('data-parent', '#accordion');
          });
        }
      } else {
        $('#accordion').html(_accordionBak);
      }
    }

    wrap4Accordion();

    $(window).on('resize', function() {
      wrap4Accordion();
    });
  }

  if($('.tapi-tea').length > 0) {
    $('.tapi-tea__nav-item[href="'+document.location.pathname+'"]').addClass('active');
  }

  // if($('.tapi-tea').length > 0) {
  //   var
  //     _header = $('.tapi-tea__header'),
  //     _headerHeight = _header.height(),
  //     _headerHeightAff = 185,
  //     _idTarget = document.location.hash;

  //   var headerAffix = function() {
  //     $(window).on('scroll resize load', function() {
  //       var _scrollTop = parseInt($(window).scrollTop());
  //       if (_scrollTop > (_headerHeight * .75)) {
  //         _header.addClass('affix');
  //         _headerHeightAff = $('.tapi-tea__header.affix').height();
  //       } else {
  //         _header.removeClass('affix');
  //       }
  //     });
  //   }

  //   headerAffix();

  //   // console.log('_headerHeight', _headerHeight);
  //   // console.log('_headerHeightAff', _headerHeightAff);

  //   $('.tapi-tea__nav-item').on('click', function() {
  //     var _id = $(this).attr('href');
  //     // window.scrollTo(0,0);
  //     document.location.hash = _id;
  //     setTimeout(function(){
  //       $('html,body').delay(100)
  //         .animate({
  //           // scrollTop: $chScrollPositions
  //           scrollTop: (($(_id).length)? $(_id).offset().top - _headerHeightAff - 15: 0)
  //         }, 200, 'swing');
  //     }, 200);
  //   });


  //   // console.log('_idTarget', _idTarget);

  //   if(_idTarget !== '') {
  //     setTimeout(function(){
  //       $.when(function(){
  //         var _scrollTop = (($(_idTarget).length)? $(_idTarget).offset().top - _headerHeightAff - 15: 0);
  //         console.log('_scrollTop', _scrollTop);
  //         $('html,body').delay(100)
  //           .animate({
  //             // scrollTop: $chScrollPositions
  //             scrollTop: _scrollTop
  //           }, 200, 'swing')
  //       }).done(function(){
  //       });
  //     }, 200);
  //   }

  //   $('.tapi-tea__logo-nav, .tapi-tea__logo').on('click', () => document.location.href = '/');
  // }

  function CoffeePlayerFiles(_playerID, _containerID) {
    var
    coffeePlayerCssSelector = {
      jPlayer: _playerID,
      cssSelectorAncestor: _containerID,
      cssSelector: {
        videoPlay: '.jp-video-play',
        play: '.jp-play',
        pause: '.jp-pause',
        stop: '.jp-stop',
        seekBar: '.jp-seek-bar',
        playBar: '.jp-play-bar',
        mute: '.jp-mute',
        unmute: '.jp-unmute',
        volumeBar: '.jp-volume-bar',
        volumeBarValue: '.jp-volume-bar-value',
        volumeMax: '.jp-volume-max',
        playbackRateBar: '.jp-playback-rate-bar',
        playbackRateBarValue: '.jp-playback-rate-bar-value',
        currentTime: '.jp-current-time',
        duration: '.jp-duration',
        title: '.jp-title',
        fullScreen: '.jp-full-screen',
        restoreScreen: '.jp-restore-screen',
        repeat: '.jp-repeat',
        repeatOff: '.jp-repeat-off',
        gui: '.jp-gui',
        noSolution: '.jp-no-solution'
      },
    },
    coffeePlayerPlaylist = [],
    coffeePlayerOptions = {
      play: function(playEvent) {
        // $(this).jPlayer("setMedia", streamCoffee);
        if(typeof ym == 'function') {
          ym(48811622,'reachGoal','coffee_player_play');
        } else {
          console.log(playEvent.jPlayer.status.media);
        }
        // Перезагружаем страницу через 12 часов после начала воспроизведения
        setTimeout(function(){
          window.location.href = '/';
        }, (12*60*60*1000));
      },
      playlistOptions: {
        autoPlay: false,
        loopOnPrevious: true,
        shuffleOnLoop: true,
        enableRemoveControls: false,
        displayTime: 'slow',
        addTime: 'fast',
        removeTime: 'fast',
        shuffleTime: 'slow'
      },
      backgroundColor: '#000000',
      audioFullScreen: false,
      swfPath: "/dist/jquery/plugin/jplayer/2.9.2/dist/jplayer",
      supplied: "html, mp3",
      preload: 'metadata',
      volume: 0.7,
      // wmode: "window",
      useStateClassSkin: true,
      autoBlur: false,
      smoothPlayBar: false,
      keyEnabled: true
    },
    coffeePlayer = {};

    var currentDate = new Date();
    var timestamp = currentDate.getTime();

    $.post("/stream/mp3.json?nocache=-" + timestamp, {
      'type': 'mp3',
      'token': $('[name="csrf-token"]').attr('content')
    })
      .done(function(response) {
        var _json = JSON.parse(response);
        if(_json.data) {
          coffeePlayerPlaylist = _json.data;
          coffeePlayer = new jPlayerPlaylist(coffeePlayerCssSelector, coffeePlayerPlaylist, coffeePlayerOptions);
          $('.jp-shuffle').trigger('click');
        }
      }).fail(function(error){
        console.error(error);
      });

    // $.getJSON("/stream/mp3.json?nocache=" + timestamp)
    //   .done(function(response) {
    //     if(response.data) {
    //       coffeePlayerPlaylist = response.data;
    //       coffeePlayer = new jPlayerPlaylist(coffeePlayerCssSelector, coffeePlayerPlaylist, coffeePlayerOptions);
    //       $('.jp-shuffle').trigger('click');
    //     }
    //   }).fail(function(error){
    //     console.error(error);
    //   });
  }

  function CoffeePlayerStream(_playerID, _containerID) {
    // $(_containerID).find('.jp-progress').hide();
    // $(_containerID).find('.jp-time-holder').hide();
    // $(_containerID).find('.jp-toggles').hide();
    // $(_containerID).find('.jp-details').hide();
    // $(_containerID).find('.jp-playlist').hide();
    // $(_containerID).find('.jp-no-solution').hide();

    var
    coffeePlayerCssSelector = {
      jPlayer: _playerID,
      cssSelectorAncestor: _containerID,
      cssSelector: {
        videoPlay: '.jp-video-play',
        play: '.jp-play',
        pause: '.jp-pause',
        stop: '.jp-stop',
        seekBar: '.jp-seek-bar',
        playBar: '.jp-play-bar',
        mute: '.jp-mute',
        unmute: '.jp-unmute',
        volumeBar: '.jp-volume-bar',
        volumeBarValue: '.jp-volume-bar-value',
        volumeMax: '.jp-volume-max',
        playbackRateBar: '.jp-playback-rate-bar',
        playbackRateBarValue: '.jp-playback-rate-bar-value',
        currentTime: '.jp-current-time',
        duration: '.jp-duration',
        title: '.jp-title',
        fullScreen: '.jp-full-screen',
        restoreScreen: '.jp-restore-screen',
        repeat: '.jp-repeat',
        repeatOff: '.jp-repeat-off',
        gui: '.jp-gui',
        noSolution: '.jp-no-solution'
      },
    },
    coffeePlayerPlaylist = [],
    coffeePlayerOptions = {
      play: function(playEvent) {
        // $(this).jPlayer("setMedia", streamCoffee);
        if(typeof ym == 'function') {
          ym(48811622,'reachGoal','coffee_player_play');
        } else {
          console.log(playEvent.jPlayer.status.media);
        }
        // // Перезагружаем страницу через 12 часов после начала воспроизведения
        // setTimeout(function(){
        //   window.location.href = '/';
        // }, (12*60*60*1000));
      },
      playlistOptions: {
        autoPlay: false,
        loopOnPrevious: true,
        shuffleOnLoop: true,
        enableRemoveControls: false,
        displayTime: 'slow',
        addTime: 'fast',
        removeTime: 'fast',
        shuffleTime: 'slow'
      },
      backgroundColor: '#000000',
      audioFullScreen: false,
      swfPath: "/dist/jquery/plugin/jplayer/2.9.2/dist/jplayer",
      supplied: "html, mp3",
      preload: 'none',
      volume: 0.7,
      // wmode: "window",
      useStateClassSkin: true,
      autoBlur: false,
      smoothPlayBar: false,
      keyEnabled: true
    },
    coffeePlayer = {};

    var currentDate = new Date();
    var timestamp = currentDate.getTime();

    $.post("/stream/mp3.json?nocache=-" + timestamp, {
      'type': 'mp3',
      'token': $('[name="csrf-token"]').attr('content')
    })
      .done(function(response) {
        var _json = JSON.parse(response);
        if(_json.data) {
          coffeePlayerPlaylist = _json.data;
          coffeePlayer = new jPlayerPlaylist(coffeePlayerCssSelector, coffeePlayerPlaylist, coffeePlayerOptions);
          $('.jp-shuffle').trigger('click');
        }
      }).fail(function(error){
        console.error(error);
      });

    // $.getJSON("/stream/mp3.json?nocache=" + timestamp)
    //   .done(function(response) {
    //     if(response.data) {
    //       coffeePlayerPlaylist = response.data;
    //       coffeePlayer = new jPlayerPlaylist(coffeePlayerCssSelector, coffeePlayerPlaylist, coffeePlayerOptions);
    //       $('.jp-shuffle').trigger('click');
    //     }
    //   }).fail(function(error){
    //     console.error(error);
    //   });
  }

  if($('#coffee_player').length > 0 && $('#coffee_player_container').length > 0) {
    if($('#coffee_player').hasClass('_files')) {
      CoffeePlayerFiles('#coffee_player', '#coffee_player_container');
    }

    if($('#coffee_player').hasClass('_stream')) {
      CoffeePlayerStream('#coffee_player', '#coffee_player_container');
    }
  }

  if(jQuery.fn.embedVideoYoutube !== undefined) {

    $('.embed-youtube').embedVideoYoutube({
      /**
       * default 120px * 90px
       * mqdefault 320px * 180px
       * hqdefault 480px * 360px
       * sddefault 640px * 480px
       * maxresdefault 1280px * 720px
       */
      sizePreview: 'sddefault',
      /**
       * auto resizes the preview image
       */
      autoSizePreview: true,
      /**
       * alternative cover image
       */
      alternativeCover: false,
      /**
       *  custom play icon
       */
      imagePlayContainer: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428.41 301.36" height="50"><path d="M639.64,440.2l115.76-60-115.76-60.4Z" transform="translate(-469.68 -233.97)" fill="#fff"/><path d="M893.81,299s-4.19-29.53-17-42.53c-16.27-17.07-34.56-17.16-42.9-18.16C773.9,234,684,234,684,234h-.17s-89.92,0-149.9,4.32c-8.35,1-26.64,1.09-42.91,18.16-12.84,13-17,42.53-17,42.53a647.81,647.81,0,0,0-4.28,69.33v32.51A648.06,648.06,0,0,0,474,470.15s4.19,29.53,17,42.53c16.31,17.07,37.71,16.53,47.23,18.33,34.26,3.27,145.67,4.32,145.67,4.32s90-.13,150-4.49c8.38-1,26.63-1.09,42.9-18.16,12.84-13,17-42.53,17-42.53a649,649,0,0,0,4.28-69.33V368.31A647.81,647.81,0,0,0,893.81,299ZM639.64,440.2V319.82l115.76,60.4Z" transform="translate(-469.68 -233.97)" fill="#e52d27"/></svg>',
      /**
       * opacity
       */
      imagePlayOpacity: .85,
      /**
       * callback function
       */
      callback: function() {},
      /**
       *  playlist, search, or user_uploads
       */
      listType: '',
      /**
       * determines the content to be loaded into the player.
       */
      list: '',
      /**
       * enables autoplay
       */
      autoplay: 1,
      /**
       * setting the parameter's value to 1 causes closed captions to be shown by default, even if the user has turned captions off.
       */
      cc_load_policy: 0,
      /**
       * player color
       */
      color: 'red',
      /**
       * enables video controls
       */
      controls: 1,
      /**
       * disables keyboard interactions
       */
      disablekb: 0,
      /**
       * uses Youtube iFrame API
       */
      enablejsapi: 0,
      /**
       * end time
       */
      end: '',
      /**
       * shows fullscreen control
       */
      fs: 1,
      /**
       * specifies the language
       */
      hl: '',
      /**
       * setting the parameter's value to 1 causes video annotations to be shown by default, whereas setting to 3 causes video annotations to not be shown by default. The default value is 1.
       */
      iv_load_policy: 1,
      /**
       * enables infinite loop
       */
      loop: 0,
      /**
       * hides the logo
       */
      modestbranding: 0,
      /**
       *  provides an extra security measure for the IFrame API and is only supported for IFrame embeds
       */
      origin: '',
      /**
       * a list of video IDs
       */
      playlist: '',
      /**
       *  controls whether videos play inline or fullscreen
       */
      playsinline: 0,
      /**
       * indicates whether the player should show related videos when playback of the initial video ends
       */
      rel: 0,
      /**
       * start time
       */
      start: 0
    });

  }

  //Анимация элементов с классом .jq-uprise
  $(window).on('scroll', function() {
    var scrollTop = parseInt($(window).scrollTop());
    $('.jq-uprise').each(function (index, value){
      if ((parseInt($(this).offset().top) - scrollTop) < 550) {
        $(this).addClass('_show');
      }
    });
  });

  //Анимация цифр
  if ($('.job').length > 0) {
    var show = true;
    var countbox = $('.job__map-counter');
    $(window).on("scroll load resize", function () {
      if (!show) return false; // Отменяем показ анимации, если она уже была выполнена
      var w_top = $(window).scrollTop(); // Количество пикселей на которое была прокручена страница
      var e_top = countbox.offset().top; // Расстояние от блока со счетчиками до верха всего документа
      var w_height = $(window).height(); // Высота окна браузера
      var d_height = $(document).height(); // Высота всего документа
      var e_height = countbox.outerHeight(); // Полная высота блока со счетчиками
      if (w_top + 550 >= e_top || w_height + w_top == d_height || e_height + e_top < w_height) {
        $('.jq-num').spincrement({
          duration: 2000
        });

        $('.jq-num-3').spincrement({
          thousandSeparator: " ",
          duration: 1300
        });

        show = false;
      }
    });
  }

  //Job video slider
  var maxOrder = 1;
  $('.video-slider__item').each(function() {
    var itemOrder = +$(this).attr('data-attribute');
    maxOrder = itemOrder < maxOrder ? maxOrder : itemOrder;
  });

  $('.video-slider__control').on('click', function() {
    var currentConrol = $(this);
    var newItemOrder;

    function changeOrder() {
      $('.video-slider__item').each(function() {
        var currentItemOrder = +$(this).attr('data-attribute');
        if (currentConrol.hasClass('_prev')) {
          newItemOrder = currentItemOrder < maxOrder ? (currentItemOrder + 1) : 1;
        } else {
          newItemOrder = currentItemOrder > 1 ? (currentItemOrder - 1) : maxOrder;
        }
        $(this).attr('data-attribute', newItemOrder);
      });
    }

    if (currentConrol.hasClass('_prev') || (currentConrol.hasClass('_next') && (window.innerWidth < 1200))) {
      changeOrder();
    } else {
      $('.video-slider__item[data-attribute="1"]').addClass('exit');
      $('.video-slider__item:not([data-attribute="1"])').addClass('move-left');

      setTimeout (function () {
        changeOrder();
        $('.video-slider__item').removeClass('exit move-left');
        $('.video-slider__item[data-attribute="3"]').addClass('appear'); //если 2 кадра, то $('.video-slider__item[data-attribute="2"]')
        setTimeout (function () {
          $('.video-slider__item.appear').removeClass('appear');
        }, 500);
      }, 600);
    }
  });

  // if ($('.video').length > 0) {
  //   $('.video-slider__item').on('click', function() {
  //     var _self = $(this);
  //     var modalId = _self.data('target');
  //     var videoId = $(modalId).find('.video__media').attr('data-attribute');
  //     var srcValue = 'https://www.youtube.com/embed/' + videoId + '?rel=0&showinfo=0&autoplay=1&fs=0';
  //     $(modalId).find('.video__media').attr("src", srcValue);
  //     $(modalId).on('hidden.bs.modal', function (event) {
  //       $(modalId).find('.video__media').removeAttr('src');
  //     })
  //   });
  // }

  if ($('.video').length > 0) {
    $('.video-slider__item').on('click', function (){
      var _self = $(this),
        modalId = _self.data('target'),
        $video = $(modalId).find('.video'),
        videoId = _self.attr('data-videoid'),
        videoHost = _self.attr('data-host'),
        videoOId = _self.attr('data-vkoid'),
        embedAttr = {
          'data-attribute': videoId,
          'src': 'https://www.youtube.com/embed/' + videoId + '?rel=0&showinfo=0&autoplay=1&fs=0',
          'allowfullscreen': 'allowfullscreen',
          'allow': 'autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;'
        },
        $embed = $('<iframe>');

      // console.log('videoId', videoId);
      // console.log('videoHost', videoHost);
      // console.log('videoOId', videoOId);

      if(videoHost !== undefined && videoHost == 'vk') {
        embedAttr = {
          'data-attribute': videoId,
          'data-host': videoHost,
          'data-vkoid': videoOId,
          'src': 'https://vk.com/video_ext.php?oid=-' + videoOId + '&id=' + videoId + '&hd=1&autoplay=1',
          'allowfullscreen': 'allowfullscreen',
          'allow': 'autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;'
        }
      }
      // console.log('embedAttr', embedAttr);
      $embed
        .addClass('video__media')
        .attr(embedAttr);

      $video.empty();
      $video.append($embed);

      $(modalId).on('hidden.bs.modal', function (event) {
        $(modalId).find('.video__media').removeAttr('src').attr('aria-hidden', 'true');
      });

      // return false;
    });
  }

  function prepositions() {
    if($('.prepositions').length > 0) {
      $('.prepositions').each(function() {
        var _self = $(this);
        var str = _self.html();
        str = (str).replace(/(\s)([а-я+]{1,3})(\s)/gu, '$1$2&nbsp;');
        _self.html(str);
      });
    } else {
      return true;
    }
  }

  $.when(prepositions())
    .done(function(){
      lazyloadCall();
    });

  function FranchiseFormGroupValidation($group, $fieldsRequired = []) {
    if($group.length > 0) {
      var gCheckbox = $group.find('[type="checkbox"]');
      // gCheckbox.prop('required', true);
      gCheckbox.prop('required', !gCheckbox.is(':checked'));

      if($fieldsRequired.length > 0) {
        gCheckbox.on('change', function(){
          gCheckbox.prop('required', !gCheckbox.is(':checked'));
          for (let index = 0; index < $fieldsRequired.length; index++) {
            const _fieldRequired = $fieldsRequired[index];
            $group.find('[name="FranchiseForm[' + $(this).data('relatedfield') + '][' + _fieldRequired + ']"]').prop('required', $(this).is(':checked'));
          }
        });
      } else {
        gCheckbox.on('change', function(){
          gCheckbox.prop('required', !gCheckbox.is(':checked'));
          $group.find('[name="FranchiseForm[' + $(this).data('relatedfield') + ']"]').prop('required', $(this).is(':checked'));
        });
      }
    }
  }

  if($('#franchise_form').length > 0) {
    FranchiseFormGroupValidation($('[name="specialization"]'), [
      'legalname',
      'inn',
      'ogrn',
      'phone',
      'email'
    ]);
    FranchiseFormGroupValidation($('[name="subdivision"]'));
    FranchiseFormGroupValidation($('[name="source"]'));

    if(document.location.hostname == 'localhost') {

      var $testJsonStr = {
        "FranchiseForm": {
          "lastname": "Тестовый",
          "firstname": "Тест",
          "middlename": "Тестович",
          "phone": "+7(900)000-00-01",
          "email": "test@te.st",
          "specialization": {
            "catering": 1,
            "catering_descr": {
              "legalname": "Тестович",
              "inn": "1111111111",
              "ogrn": "1111111111111",
              "phone": "+7(900)000-00-01",
              "email": "test@te.st",
              "websites": "",
              "account": "",
              "other_contacts": ""
            },
            "retail": 0,
            "retail_descr": {
              "legalname": "",
              "inn": "",
              "ogrn": "",
              "phone": "",
              "email": "",
              "websites": "",
              "account": "",
              "other_contacts": ""
            },
            "business": 0,
            "business_descr": {
              "legalname": "",
              "inn": "",
              "ogrn": "",
              "phone": "",
              "email": "",
              "websites": "",
              "account": "",
              "other_contacts": ""
            },
            "sweetshop": 0,
            "sweetshop_descr": {
              "legalname": "",
              "inn": "",
              "ogrn": "",
              "phone": "",
              "email": "",
              "websites": "",
              "account": "",
              "other_contacts": ""
            },
            "other_field": 0,
            "other_field_descr": "",
          },
          "region_current": "Омск",
          "region_planned": "Омск",
          "subdivision": {
            "legal": 1,
            "accounting": 0,
            "sales": 0,
            "marketing": 0,
            "commerce": 0,
            "hr": 0,
            "control": 0,
            "technique": 0,
            "storage": 0,
            "transport": 0,
            "it": 0,
            "protection": 0,
            "production": 0,
            "other_subdivision": 0,
            "other_subdivision-descr": "",
          },
          "source": {
            "advertising": 1,
            "site": 0,
            "friends": 0,
            "partner": 0,
            "other_from": 0,
            "other_from-descr": "",
          },
          "reCaptcha": "",
          "agree": 1,
          "isTest": 0
        }
      };

      var FF = $('#franchise_form');
      console.log('FranchiseForm', $testJsonStr.FranchiseForm);

      for (const key in $testJsonStr.FranchiseForm) {
        if (Object.prototype.hasOwnProperty.call($testJsonStr.FranchiseForm, key)) {
          const element = $testJsonStr.FranchiseForm[key];
          var _input = FF.find('[name="FranchiseForm['+ key +']"]');
          // console.log('node', _input);
            console.log('node/name', _input.attr('name'));
            console.log('node/type', _input.attr('type'));
          if(_input.attr('type') == 'checkbox' && _input.attr('value') == '1') {
            console.log('node/value', _input.attr('value'));
            _input.prop('checked', true);
          } else {
            _input.val(element);
          }

          if(typeof element == 'object') {
            for (const keyChild in element) {
              if (Object.prototype.hasOwnProperty.call(element, keyChild)) {
                const elementChild = element[keyChild];
                var _inputChild = FF.find('[name="FranchiseForm['+ key +'][' + keyChild + ']"]');
                // console.log('node/child', _inputChild);
                console.log('node/child/name', _inputChild.attr('name'));
                console.log('node/child/type', _inputChild.attr('type'));
                if(_inputChild.attr('type') == 'checkbox' && _input.attr('value') == '1') {
                  console.log('node/child/value', _inputChild.attr('value'));
                  _inputChild.prop('checked', true);
                } else {
                  _inputChild.val(elementChild);
                }

                if(typeof elementChild == 'object') {
                  for (const keyChildChild in elementChild) {
                    if (Object.prototype.hasOwnProperty.call(elementChild, keyChildChild)) {
                      const elementChildChild = elementChild[keyChildChild];
                      var _inputChildChild = FF.find('[name="FranchiseForm['+ key +'][' + keyChild + '][' + keyChildChild + ']"]');
                      // console.log('node/child/child', _inputChildChild);
                      console.log('node/child/child/name', _inputChildChild.attr('name'));
                      console.log('node/child/child/type', _inputChildChild.attr('type'));
                      if(_inputChildChild.attr('type') == 'checkbox' && _inputChildChild.attr('value') == '1') {
                        console.log('node/child/child/value', _inputChildChild.attr('value'));
                        _inputChildChild.prop('checked', true);
                      } else {
                        _inputChildChild.val(elementChildChild);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      // $('#franchise_form')

      $('#franchise_form').on('submit', function(){
        var serializeArray = getFormData($(this));
        var flatJSON = JSON.stringify(serializeArray);
        console.log('flatJSON', flatJSON);
        return false;
      });
    }
  }

  if (($('.js-tab-content').length > 0) && (window.innerWidth > 767)) {
    $('.js-tab-content').addClass('tab-content');
  }

});